import React from "react"
import moment from "moment";
import { getContactList } from "relay/campaigns"
import { getCampaignsByPropertyIdsSelected } from "../utils"
import EmptyViewContact from "images/EmptyViewContact.svg"
import { compare } from "content/utils/commonParsing"
import { getDate } from "content/utils/commonParsing";
import Loading from "storybookComponents/Loader"
import EmptyView from "../Components/NoPropView"
import TableHeader from "../Components/tableHeader"
import StyledTable from 'components/TableComponent';
import PropertyFilterBar from "../ByProperty/propertyFilterBar"
import SelectorComponent from "components/SelectorComponents"
import {
  csvHeadersContacts,
  getContactRows,
  getColumnsForContact,
  getData
} from "../common"

const tableFilterOption = [
  {
    id: "All",
    label: "All",
  },
  {
    id: "Yes",
    label: "Yes",
  },
  {
    id: "No",
    label: "No",
  },
];


const tableReferredOption = [
  {
    id: "all",
    label: "All",
  },
  {
    id: "referred",
    label: "Referred",
  },
  {
    id: "not_referred",
    label: "Not Referred",
  },
];


const statusOptionResidents = [
  {
    id: "all",
    value: "All",
  },
  {
    id: "referred",
    value: "Referred",
  },
  {
    id: "not_referred",
    value: "Not Referred",
  },
];



const statusOptionFriends = [
  {
    id: "all",
    value: "All",
  },
  {
    id: "Yes",
    value: "Yes",
  },
  {
    id: "No",
    value: "No",
  },
];

const contactFilterValue = [
  {
    id: "enrolled",
    value: "Residents"
  },
  {
    id: "friends",
    value: "Friends"
  },
  {
    id: "leased",
    value: "Leased"
  },
]


const ContactList = ({ subMenu, subOrgDetails, propertiesOfOrg, allCampaignsByProperties, classes, history, handleSelectCampaign, setReportData, previewReport }) => {
  const [monthRange, setMonthRange] = React.useState({ startAt: moment().startOf("month"), endAt: moment().endOf("month"), label: "This Month" })
  const [selectedProperties, setSelectedProperties] = React.useState([subOrgDetails.id]);
  const [selectedCampaigns, setSelectedCampaigns] = React.useState([]);
  const [campaignsForDropDown, setCampaignsForDropDown] = React.useState([]);
  const [status, setStatus] = React.useState(['all'])
  const [rows, setRows] = React.useState(null);
  const [csvData, setCsvData] = React.useState([])
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [showFilter, setShowFilter] = React.useState(false);
  const [contactFilter, setContactFilter] = React.useState(['enrolled'])


  const handleClickCampaign = (item) => {
    handleSelectCampaign({
      ...item,
      status,
    })
  }



  React.useEffect(() => {
    if (previewReport) {
      let params = JSON.parse(previewReport.params)
      let propertiesParams = params.property_ids || [subOrgDetails.id];
      let campaignsParams = params.campaigns_id || [];
      let contactParams = params.type_status ? [params.type_status] : ['enrolled']
      let statusParams = [params.leased_status || params.referred_status]
      let monthRangeParams = { startAt: moment().startOf("month"), endAt: moment().endOf("month"), label: "This Month" }
      if (params.start_date && params.end_date && params.range_label) {
        monthRangeParams = { startAt: moment(params.start_date).startOf("month"), endAt: moment(params.end_date).endOf("month"), label: params.range_label }
      }
      setStatus(statusParams)
      setSelectedProperties(propertiesParams);
      setContactFilter(contactParams);
      setMonthRange(monthRangeParams);
      let list = getCampaignsByPropertyIdsSelected(propertiesParams, allCampaignsByProperties);
      setCampaignsForDropDown(list);
      let selectedCampaigns = [];
      for (let i = 0; i < list.length; i++) {
        let campaigns = list[i].list;
        let filteredCampaigns = campaigns.filter(value => campaignsParams.includes(value.id));
        let campaignsIds = filteredCampaigns.map(e => e.id)
        if (campaignsIds.length > 0) {
          selectedCampaigns.push({
            id: list[i].id,
            list: campaignsIds
          })
        }
      }
      setSelectedCampaigns(selectedCampaigns)
      getContactListData(selectedCampaigns, contactParams[0], statusParams[0], monthRangeParams)
    } else {
      let list = getCampaignsByPropertyIdsSelected([subOrgDetails.id], allCampaignsByProperties)
      setCampaignsForDropDown(list);
      let obj = {
        id: list[0].id,
        list: [
          list[0].list[0].id
        ]
      }
      setSelectedCampaigns([obj])
      getContactListData([obj], contactFilter[0], status[0], monthRange)
    }

  }, [1])

  const getContactListData = async (selectedCampaigns, type, referred, monthRange) => {
    setLoading(true);
    let campaignsIds = [];
    for (var i = 0; i < selectedCampaigns.length; i++) {
      campaignsIds = [...campaignsIds, ...selectedCampaigns[i].list]
    }
    let leased = (type == 'friends' ? ((referred == 'not_referred' || referred == 'referred') ? 'all' : referred) : null)
    let _referred = (type == 'enrolled' ? ((referred == 'Yes' || referred == 'No') ? 'all' : referred) : null)
    try {
      const response = await getContactList(
        subOrgDetails.org.id,
        campaignsIds,
        type,
        _referred,
        monthRange.startAt,
        monthRange.endAt,
        leased
      );
      if (response && response.contactList) {
        setRows(getContactRows(response.contactList, classes, handleClickCampaign, true))
        setCsvData(getData(response.contactList));
        setData(response.contactList);
        let _label = monthRange.label;
        if (monthRange.label === "Custom Range") {
          let start = moment(monthRange.startAt).format("D MMM YYYY");
          let end = moment(monthRange.endAt).format("D MMM YYYY");
          _label = start + " - " + end;
          if (start === end) {
            _label = start;
          }
        }
        setReportData({
          tabName: "RAF Contact List",
          params: JSON.stringify({
            property_ids: selectedProperties,
            range_label: _label,
            report_type: "hyRaf_system_dashboard",
            start_date: moment(monthRange.startAt).format("YYYY/MM/DD"),
            end_date: moment(monthRange.endAt).format("YYYY/MM/DD"),
            org_id: subOrgDetails.org.id,
            referred_status: _referred,
            leased_status: leased,
            campaigns_id: campaignsIds,
            type_status: type
          }),
          type: "hyRaf_system_dashboard",
          month: _label
        })
        setLoading(false)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const handleSort = (field, order) => {
    let sortedData = data.slice().sort((a, b) => compare(a[field], b[field], !order))
    setRows(getContactRows(sortedData, classes, handleClickCampaign, true));
    setCsvData(getData(sortedData));
  }


  const handleChangeProperty = (selected) => {
    setSelectedProperties(selected)
    setSelectedCampaigns([])
    setCampaignsForDropDown(getCampaignsByPropertyIdsSelected(selected, allCampaignsByProperties));
  }

  const handleMonthRange = (time) => {
    setMonthRange(time);
    if (selectedCampaigns.length > 0) {
      getContactListData(selectedCampaigns, contactFilter[0], status[0], time)
    }
  }

  const handleChangeCampaigns = (selected) => {
    setSelectedCampaigns(selected)
    if (selected.length > 0) {
      getContactListData(selected, contactFilter[0], status[0], monthRange)
    } else {
      setData([])
    }
  }

  const handleStatusChange = (values) => {
    setStatus(values)
    if (selectedCampaigns.length > 0) {
      getContactListData(selectedCampaigns, contactFilter[0], values[0], monthRange)
    }
  }

  const handleShowFilter = () => {
    setShowFilter(!showFilter)
  }

  const handleFilterProperty = (f, key) => {
    if (f) {
      let filteredData = data.slice().filter(item => {
        if (item[key]) {
          return item[key].toLowerCase().includes(f.toLowerCase())
        }
      })
      setRows(getContactRows(filteredData, classes, handleClickCampaign, true))
      setCsvData(getData(filteredData))
    } else {
      setRows(getContactRows(data, classes, handleClickCampaign, true))
      setCsvData(getData(data));
    }
  }

  const handleFilter = (filterValue) => {
    if (filterValue && filterValue.id !== "All") {
      let filteredData = data.filter(e => e.leased === (filterValue.id === "Yes" ? true : false))
      setCsvData(getData(filteredData))
      setRows(getContactRows(filteredData, classes, handleClickCampaign, true))
    } else {
      setCsvData(getData(data))
      setRows(getContactRows(data, classes, handleClickCampaign, true))
    }
  }


  const handleReferredFilter = (filterValue) => {
    if (filterValue && filterValue.id !== "all") {
      let filteredData = data.filter(e => e.referredStatus == (filterValue.id === "referred" ? true : false))
      setCsvData(getData(filteredData))
      setRows(getContactRows(filteredData, classes, handleClickCampaign, true))
    } else {
      setCsvData(getData(data))
      setRows(getContactRows(data, classes, handleClickCampaign, true))
    }
  }


  const handleDateFilter = (e) => {
    handleFilterProperty(getDate(e), "leasedDate")
  }

  const handleContactChange = (values) => {
    setContactFilter(values)
    if (values[0] !== contactFilter[0]) {
      setStatus(['all'])
    }
    if (selectedCampaigns.length > 0) {
      getContactListData(selectedCampaigns, values[0], status[0], monthRange)
    }
  }

  const getCustomLabelForContact = (selected, count, name, open) => {
    if (!name) {
      return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Contact</div>
    }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>Contact({name})</div>
  }

  const getColumns = () => {
    const array = getColumnsForContact(classes, handleFilterProperty, handleDateFilter, tableFilterOption[0], handleFilter, tableFilterOption, tableReferredOption, tableReferredOption[0], handleReferredFilter)
    if (contactFilter[0] == 'enrolled') {
      return array.slice(0, 6)
    }
    if (contactFilter[0] == 'friends') {
      return [...array.slice(0, 2), ...array.slice(6, 9)]
    }
    return [...array.slice(0, 2), ...array.slice(6, 8), ...array.slice(9)]

  }

  const getCsvHeadersContacts = () => {
    if (contactFilter[0] == 'enrolled') {
      return csvHeadersContacts.slice(0, 6)
    }
    if (contactFilter[0] == 'friends') {
      return [...csvHeadersContacts.slice(0, 2), ...csvHeadersContacts.slice(6, 9)]
    }
    return [...csvHeadersContacts.slice(0, 2), ...csvHeadersContacts.slice(6, 8), ...csvHeadersContacts.slice(9)]
  }


  const selectContact = <SelectorComponent
    optionValue={contactFilterValue}
    onChange={handleContactChange}
    singleSelect={true}
    value={contactFilter}
    getCustomLabel={getCustomLabelForContact}
    disableSearch={true}
    disableAllSelect={true}
    height={145}
    width={150}
  />


  return (
    <div>
      <PropertyFilterBar
        propertiesOfOrg={propertiesOfOrg}
        selectedProperties={selectedProperties}
        selectedCampaigns={selectedCampaigns}
        campaignsForDropDown={campaignsForDropDown}
        monthRange={monthRange}
        subOrgDetails={subOrgDetails}
        handleChangeProperty={handleChangeProperty}
        handleMonthRange={handleMonthRange}
        handleChangeCampaigns={handleChangeCampaigns}
        classes={classes}
        status={status}
        handleStatusChange={handleStatusChange}
        statusOption={contactFilter[0] == 'enrolled' ? statusOptionResidents : contactFilter[0] == 'friends' ? statusOptionFriends : null}
        labelKey={contactFilter[0] == 'enrolled' ? 'Referred Status' : contactFilter[0] == 'friends' ? "Leased" : null}
      >
        {selectContact}
      </PropertyFilterBar>
      <div className={classes.bottomViewCampaignAll}>
        {
          loading ? <Loading /> : (data.length == 0) ? <EmptyView message="No contact to show up for the selected filters." image={EmptyViewContact} /> :
            <div>
              <TableHeader
                title={contactFilter[0] == 'enrolled' ? `Residents (${data.length})` : contactFilter[0] == 'friends' ? `Friends (${data.length})` : `Leased (${data.length})`}
                csvData={csvData}
                csvHeaders={getCsvHeadersContacts()}
                fileName="contact.csv"
                showFilter={showFilter}
                handleShowFilter={handleShowFilter}
              />
              <StyledTable
                columns={getColumns()}
                rows={rows}
                sortHandler={handleSort}
                className={classes.tableContainerCampaignRoot}
                defaultSortBy="resident"
                showFilter={showFilter}
              />
            </div>
        }
      </div>
    </div>
  )
}

export default ContactList